import { useMemo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { ThreadHistory } from './ThreadHistory';
import { MessageComposer } from './MessageComposer';
import { TicketDetailsPanel } from './TicketDetailsPanel';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { ATTACHMENTS_PANEL_OVERLAY_BREAKPOINT } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function TicketThreadViewer({
  threads,
  isCreatingThread,
  isLoading,
  ticketThread,
  isPanelOpen,
  setIsPanelOpen,
  selectedDetailsPanelTab,
  setSelectedDetailsPanelTab
}) {
  var _ticketThread$data2, _ticketThread$data3, _ticketThread$data4;
  const isAtAttachmentsBreakpoint = useBreakpoint(ATTACHMENTS_PANEL_OVERLAY_BREAKPOINT);
  const messages = useMemo(() => {
    var _ticketThread$data;
    return ((_ticketThread$data = ticketThread.data) === null || _ticketThread$data === void 0 || (_ticketThread$data = _ticketThread$data.pagedThreadHistory) === null || _ticketThread$data === void 0 ? void 0 : _ticketThread$data.results.filter(message => Boolean(message.sender)).sort((a, b) => a.timestamp - b.timestamp)) || [];
  }, [ticketThread.data]);
  const responders = ((_ticketThread$data2 = ticketThread.data) === null || _ticketThread$data2 === void 0 ? void 0 : _ticketThread$data2.responders) || {};
  const attachmentsMap = ((_ticketThread$data3 = ticketThread.data) === null || _ticketThread$data3 === void 0 ? void 0 : _ticketThread$data3.attachmentsMap) || {};
  const sensitiveAttachmentsMetadata = ((_ticketThread$data4 = ticketThread.data) === null || _ticketThread$data4 === void 0 ? void 0 : _ticketThread$data4.sensitiveAttachmentsMetadata) || {};
  return /*#__PURE__*/_jsxs(Flex, {
    flex: "1",
    flexDirection: "row",
    minInlineSize: "0",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flex: "1",
      flexDirection: "column",
      minInlineSize: "300px",
      children: [/*#__PURE__*/_jsx(Flex, {
        flex: "1",
        overflow: "hidden",
        minInlineSize: "100%",
        children: /*#__PURE__*/_jsx(ThreadHistory, {
          threads: threads,
          isLoading: isLoading,
          isCreatingThread: isCreatingThread,
          hasMore: ticketThread.hasMore,
          fetchMore: ticketThread.fetchMore,
          messages: messages,
          isFetchingMore: ticketThread.loading,
          responders: responders,
          attachmentsMap: attachmentsMap,
          sensitiveAttachmentsMetadata: sensitiveAttachmentsMetadata,
          setIsPanelOpen: setIsPanelOpen,
          showOpenPanelButton: isAtAttachmentsBreakpoint
        })
      }), /*#__PURE__*/_jsx(Flex, {
        blockSize: "200px",
        flexShrink: "0",
        borderBlockStartWidth: "100",
        borderBlockStartStyle: "solid",
        borderColor: "border-core-disabled",
        children: /*#__PURE__*/_jsx(MessageComposer, {
          isLoading: isLoading || isCreatingThread
        })
      })]
    }), /*#__PURE__*/_jsx(TicketDetailsPanel, {
      showAsOverlay: isAtAttachmentsBreakpoint,
      isOpen: isPanelOpen,
      setIsOpen: setIsPanelOpen,
      selectedTab: selectedDetailsPanelTab,
      setSelectedTab: setSelectedDetailsPanelTab
    })]
  });
}